import React from 'react';
import { MDBCard, MDBCardTitle, MDBCardText, MDBRow, MDBCol, MDBIcon } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Header from './ComponentFragments/Header';
import Formatter from '../Utilities/Formatter';


export default class TeamTransactions extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            transactionData: []
        }
        this.formatter = new Formatter();
        this.TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
    }


    async componentWillMount() {
        this.props.loaderOn();
        var dl = new DataLayer();
        var path = '';
        switch (this.TMAUser.data.statusCode1.toUpperCase()) {
            case 'T':
                path = path + '?status=T'
                break
            case 'M':
                path = path + '?status=M'
                break;
            
        }

        await dl.Get('/teamleader/getteamtransactions' + path, 200).then((response) => {
            var test = "";
            this.setState({
                transactionData: response.data
            });
            this.props.loaderOff();
        })
    }


    render() {
        let circle = {
            padding: 10,
            margin: 5,
            display: "inline-block",
            backgroundColor: "#ad1896",
            borderRadius: "50%",
            width: 45,
            height: 45,
            textAlign: "center",
            color: "white"
        }

        const amountFont = { fontSize: "11px" }
        var header = '';
        switch (this.TMAUser.data.statusCode1.toUpperCase()) {
            case 'T':
                header = "Team Transactions"
                break
            case 'M':
                header = "Unit Transactions"
                break;

        }
        return (

            <div>
                <Header headerText={ header} hideSearch={true} />
                <MDBRow>
                    {
                        this.state.transactionData.map((transaction) => {
                            return (
                                <MDBCol xl="3" lg="3" md="4" sm="12" className="mb-r" >
                                    <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                                        <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}>Week No:&nbsp;{transaction.newTransWeekNo}</MDBCardTitle>
                                        <MDBCardTitle style={{ fontSize: "16px" }}>Week's Start Date:&nbsp;{transaction.wedsDate}</MDBCardTitle>
                                        <hr />
                                        <MDBCardText>
                                            <MDBRow>
                                                <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r">
                                                    <div>
                                                    <div style={circle}>
                                                        <p style={{ paddingTop: "5px", fontSize: "10px" }}>Sun</p>
                                                        </div>
                                                        
                                                        <span style={amountFont}><strong>{this.formatter.formatCurrency(transaction.sundaySales)}</strong></span>
                                                    </div>
                                                    <div>
                                                        <div style={circle}>
                                                        <p style={{ paddingTop: "5px", fontSize: "10px" }}>Tue</p>
                                                        </div><span style={amountFont}><strong>{this.formatter.formatCurrency(transaction.tuesdaySales)}</strong></span>
                                                        </div>
                                                    <div>
                                                        <div style={circle}>
                                                        <p style={{ paddingTop: "5px", fontSize: "10px" }}>Thu</p>
                                                        </div><span style={amountFont}><strong>{this.formatter.formatCurrency(transaction.thursdaySales)}</strong></span>
                                                        </div>
                                                    <div>
                                                        <div style={circle}>
                                                        <p style={{ paddingTop: "5px", fontSize: "10px" }}>Sat</p>
                                                        </div><span style={amountFont}><strong>{this.formatter.formatCurrency(transaction.saturdaySales)}</strong></span>
                                                        </div>
                                                </MDBCol>
                                                <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r">
                                                    <div>
                                                        <div style={circle}>
                                                            <p style={{ paddingTop: "5px", fontSize: "10px" }}>Mon</p>
                                                        </div><span style={amountFont}><strong>{this.formatter.formatCurrency(transaction.mondaySales)}</strong></span>
                                                    </div>

                                                    <div>
                                                        <div style={circle}>
                                                            <p style={{ paddingTop: "5px", fontSize: "10px" }}>Wed</p>
                                                        </div><span style={amountFont}><strong>{this.formatter.formatCurrency(transaction.wednesdaySales)}</strong></span>
                                                    </div>
                                                    <div>
                                                        <div style={circle}>
                                                            <p style={{ paddingTop: "5px", fontSize: "10px"}}>Fri</p>
                                                        </div><span style={amountFont}><strong>{this.formatter.formatCurrency(transaction.fridaySales)}</strong></span>
                                                    </div>
                                                </MDBCol>
                                                
                                            </MDBRow>
                                        </MDBCardText>
                                        <hr />
                                        <MDBCardText>
                                            <MDBRow>
                                                <MDBCol sm="12" className="mb-r" style={{ textAlign: "center" }}>
                                                    <MDBIcon icon="coins" />&nbsp;Total Sales:&nbsp;<strong>{this.formatter.formatCurrency(transaction.totalWeekSales)}</strong>
                                                </MDBCol>
                                            </MDBRow>
                                        </MDBCardText>
                                    </MDBCard>
                                </MDBCol>
                            );
                        })
                    }
                </MDBRow>

            </div>
        );
    }
}